import React from 'react'
import NTFSInputField from "./NTFSInputField";
import { SET_MAX_FILE_SIZE } from "../dataSourceConstants";
function NTFSMaxFileSize(props) {
  const { ntfsMaxFileSize } = props;
  return (
    <NTFSInputField
      {...props}
      label="Max File Size"
      value={ntfsMaxFileSize}
      placeholder="Max File Size"
      actionType={SET_MAX_FILE_SIZE}
      errorKey="ntfsMaxFileSize"
    />
  )
}

export default NTFSMaxFileSize